<aside class="flex h-full min-h-0 w-full flex-col overflow-hidden bg-white">
  @if (field(); as selected) {
    <div class="flex shrink-0 flex-col gap-1 border-b border-slate-100 px-4 py-4">
      <div class="flex min-w-0 flex-wrap items-center gap-2">
        <h2 class="text-sm font-semibold text-slate-950">
          {{ isLayoutField() ? 'Configure block' : 'Configure field' }}
        </h2>
        <span class="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium capitalize text-slate-600">
          {{ selected.type }}
        </span>
      </div>
      <p class="text-xs leading-5 text-slate-500">
        @if (isLayoutField()) {
          Layout blocks help structure the form. They are not submitted as answers.
        } @else {
          Update labels, options, and validation for this field.
        }
      </p>
    </div>

    <div class="min-h-0 flex-1 overflow-y-auto">
      @switch (selected.type) {
        @case ('heading') {
          <app-heading-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('paragraph') {
          <app-paragraph-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('divider') {
          <app-divider-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('spacer') {
          <app-spacer-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('text') {
          <app-text-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('textarea') {
          <app-textarea-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('email') {
          <app-email-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('phone') {
          <app-phone-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('number') {
          <app-number-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('currency') {
          <app-currency-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('url') {
          <app-url-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('checkbox') {
          <app-checkbox-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('checkbox_group') {
          <app-checkbox-group-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('radio_group') {
          <app-radio-group-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('switch') {
          <app-switch-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('select') {
          <app-select-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('searchable_picker') {
          <app-searchable-picker-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('single_choice') {
          <app-single-choice-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('multi_choice') {
          <app-multi-choice-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('date') {
          <app-date-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('time') {
          <app-time-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('datetime') {
          <app-datetime-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('date_range') {
          <app-date-range-picker-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('time_range') {
          <app-time-range-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('slider') {
          <app-slider-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('rating') {
          <app-rating-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('range_slider') {
          <app-range-slider-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('color') {
          <app-color-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('numeric_stepper') {
          <app-numeric-stepper-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('image_picker') {
          <app-image-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('camera') {
          <app-camera-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('live_geo_coordinates') {
          <app-live-geo-coordinates-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('address_selector') {
          <app-address-selector-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('map') {
          <app-map-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('file_uploader') {
          <app-file-uploader-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('audio_recorder') {
          <app-audio-recorder-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('video_recorder') {
          <app-video-recorder-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('rich_text') {
          <app-rich-text-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('document_scanner') {
          <app-document-scanner-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('drawing') {
          <app-drawing-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('signature') {
          <app-signature-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('captcha') {
          <app-captcha-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('multi_choice_grid') {
          <app-multi-choice-grid-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('single_choice_grid') {
          <app-single-choice-grid-config-view
            [field]="selected"
            (fieldChange)="fieldChange.emit($event)" />
        }
        @case ('number_grid') {
          <app-number-grid-config-view [field]="selected"
                                  (fieldChange)="fieldChange.emit($event)"></app-number-grid-config-view>
        }
      }
    </div>

    <div class="flex shrink-0 items-center gap-2 border-t border-slate-100 px-4 py-3">
      <button
        type="button"
        class="inline-flex flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-lg bg-rose-50 px-3 py-2 text-xs font-semibold text-rose-600 transition hover:bg-rose-100"
        (click)="remove.emit()">
        <app-svg-icon src="assets/icons/trash-can-outline.svg" [size]="16" />
        Delete field
      </button>
      <button
        type="button"
        class="inline-flex flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-800 transition hover:bg-slate-50"
        (click)="duplicate.emit()">
        <app-svg-icon src="assets/icons/content-copy.svg" [size]="16" />
        Duplicate
      </button>
    </div>
  } @else {
    <div class="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
      <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-100 text-slate-500">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 7h16M4 12h10M4 17h7M17 14l3 3m0 0-3 3m3-3h-6"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-sm font-semibold text-slate-900">Select a field to configure</p>
        <p class="text-xs leading-5 text-slate-500">
          Click any field on the form preview to edit its label, options, and validators.
        </p>
      </div>
    </div>
  }
</aside>
